define([
	'internal_util/Util'
], function (
	Util
) {
	'use strict';

	/**
	 * Abstract EidClient class
	 */
	return function (id) {
		var _id;

		if (Util.isValidString(id)) {
			_id = id;
		} else {
			throw new Error('invalid eID client id: ' + id);
		}


		// public methods

		this.id = function () {
			return _id;
		};

		this.name = function () {
			throw new Error('not implemented');
		};

		this.supportsPlatorm = function () {
			throw new Error('not implemented');
		};

		this.supportsAuthenticationOption = function (authenticationOption) {
			throw new Error('not implemented');
		};

		this.supportsStatus = function () {
			throw new Error('not implemented');
		};

		this.detect = function (callbacks, errorCallbacks) {
			throw new Error('not implemented');
		};

		this.start = function (callbacks, errorCallbacks) {
			throw new Error('not implemented');
		};

		this.stop = function (callbacks, errorCallbacks) {
			throw new Error('not implemented');
		};

		this.activate = function (authenticationOption, activationUrl, callbacks, errorCallbacks) {
			throw new Error('not implemented');
		};

		this.toObject = function () {
			return _id;
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/EidClient.js
// module id = 95
// module chunks = 3